module.exports = __webpack_public_path__ + "img/TrinPodz_File_Sharing_Image.045e8204.png";